// import { useSettings } from './useSettings.ts';
// import { useSystemTheme } from './useSystemTheme.ts';

type Theme = 'light' | 'dark' | 'black';

/**
 * Returns the actual theme being displayed (eg "light" or "dark")
 * regardless of whether that's by system theme or direct setting.
 * Always return light (truth social)
 */
const useTheme = (): Theme => {
  // const { themeMode } = useSettings();
  // const systemTheme = useSystemTheme();

  return "light" //themeMode === 'system' ? systemTheme : themeMode;
};

export { useTheme };
